import { Icon, IconButton, Stack, Dialog, DialogType, DialogFooter, ChoiceGroup, PrimaryButton, DefaultButton } from "@fluentui/react";
import React, {useContext, useState, useCallback, useRef,useEffect, useMemo} from "react";
import "./Styles/ActionDetailsCss.css";
import { ContextualMenu } from '@fluentui/react';
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { addToLibraryApi, deleteStudyApi, externalDicomPushApi, getPaymentStatusOfStudy, pullPacsStudyReport, ReInferenceApi, removeFromLibraryApi, RevertCloseStudyApi, showStatusAPI, getStudyInformationFromPACS, sendReportToLIMS, getPatientDetailsAPI, submitEditPatientDetails ,updateStudyEmergencyOnlyAPI, sendHl7, sendAIReport, saveLibraryStudyTagsApi} from "../../../service/StudyListService";
import CloseStudy from "./Actions/CloseStudy";
import {SendReportEmail} from "./Actions/SendReportEmail";
import ShareStudyLink from "./Actions/ShareStudyLink";
import TATTimeline from "./Actions/TATTimeline";
import ReturnStudy from "./ReturnStudy";
import EditPatientModal from "./EditPatient/EditPatientModal";
import { useTranslation } from "react-i18next";
import userContext from "../../../context/users/UserContext";
import { MODAL_TYPE, REINFERECE_ALLOWED_MODALITY, REPORTED_TABS_NAME, REPORTED_SUBTABS_ID,RESTRICTED_STORAGE_TYPES, STORAGE_TYPE,storageType,TAB_NAME, TOAST_TYPE, USERTYPES, VDCLIMS, STUDY_SEARCH_RESULTS_ID } from "../../../constants/Constants";
import UploadHistory from "./UploadHistory/UploadHistory";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import ReportVersion from "./Modal/ReportVersion/ReportVersion";
import studylistContext from "../../../context/studylist/StudylistContext";
import themeContext from "../../../context/theme/ThemeContext";
import toastContext from "../../../context/toast/ToastContext";
import loaderContext from "../../../context/loader/LoaderContext";
import TypistAccessCode from "./Typist/TypistAccessCode";
import SendToPACS from "./Modal/SendToPACS/SendToPACS";
import GatewayStatus from "./Modal/GatewayStatusModal/GatewayStatus";
import PeerReviewAssignment from "./Modal/PeerReviewAssignment/PeerReviewAssignment";
import EvaluatorAssignment from "./Modal/EvaluatorAssignment/EvaluatorAssignment";
import PeerReviewModal from '../components/Modal/PeerReviewTimeLineModal/PeerReviewModal';
// import HistoryUploadModal from "./UploadHistory/HistoryUploadModal";
import Moment from "moment"; 
import SetEmergencyModal from "./EditPatient/SetEmergencyModal";
import StudyAuditLogsModal from "./Modal/StudyAuditLogsModal/StudyAuditLogsModal";
import { getEnv } from '../../../helpers/EnvHelper';
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import {
  filterActionMenuForGlobalSearch,
  isGlobalSearchResultsTab,
} from "../helpers/globalSearchHelpers";
import ApplyLibraryModal from "./LibraryTags/ApplyLibraryModal";

const CONTEXTUAL_MENU_CALLOUT_PROPS = { 'data-automation-id': 'studyList_actions' };

const ActionDetails = (props) => {
const [showSetEmergencyModal, setShowSetEmergencyModal] = useState(false);
  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;
  const {
    setStudyParentId,
    setOpenReportModal,
    setModalityReport,
    setFirmId,
    setIsExternal,
    setAlertSuccessModal,
    alertSuccessModal,
    externalReportingModalRef,externalReportingLoading,setExternalReportingLoading
  } = useContext(studyReportContext);

  const { showToastv2 } =
  useContext(toastContext);

  const { getThemeColor } = useContext(themeContext);

  const {dataQueryState, setDataQueryState
  ,refreshRequired, setRefreshRequired,returnedReasonCount, 
   isTypistWorkflowEnabled, studyListModalAuditEnabled, allowDeleteStudy, orderStudyDeleteEnabledFirmIds, allowStudyEdit, editPatientAccess,
   selectedValue
  } = useContext(studylistContext);

    const [t] = useTranslation();
    const linkRef = useRef(null);
    const {roles, userId ,contextSwitchUser, isActiveData, peerReviewAdmin, peerReviewEvaluator, routeToNodeEnabled} = useContext(userContext);
    let enterprise = (getEnv("REACT_APP_ENTERPRISE_PLATFORM")=="true"||getEnv("REACT_APP_ENTERPRISE_PLATFORM")==true)?true:false;
  
    let study = props.data.row.original;
    let studyId = props.data.row.original.id;
    let patientName = props.data.row.original.patientName;
    let patientId = props.data.row.original.patientId;
    let orderId= props.data.row.original.orderId;
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDeleteResponseModal, setShowDeleteResponseModal] = useState(false);
    const [showDeleteResponseMsg, setShowDeleteResponseMsg] = useState("");
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showReInferenceModal, setShowReInferenceModal] = useState(false);
    const [showCloseStudyModal, setShowCloseStudyModal] = useState(false);
    const [showLibraryModal, setShowLibraryModal] = useState(false);
    const [skipLibraryTags, setSkipLibraryTags] = useState(false);    
    const [showCloseStudyResponseModal, setShowCloseStudyResponseModal] = useState(false);
    const [showCloseStudyReponseMsg, setShowCloseStudyReponseMsg] = useState("");
    const [showRevertConfirmModal, setShowRevertConfirmModal] = useState(false);
    const [showRevertReponseModal, setShowRevertReponseModal]  = useState(false);
    const [showRevertStudyResponseMsg, setShowRevertStudyResponseMsg] = useState("");
    const [showLibraryResponseModal, setShowLibraryResponseModal] = useState(false);
    const [showLibraryResponseMsg, setShowLibraryResponseMsg] = useState("");
    const [showShareStudyLinkModal, setShowShareStudyLinkModal] = useState(false);
    const [showStudysharingResponse, setShowStudysharingResponse] = useState(false);
    const [showStudySharingResponseMsg, setShowStudySharingResponseMsg] = useState("");
    const [showTATTimelineModal, setShowTATTimelineModal] = useState(false);
    const [showPeerReviewModal,setShowPeerReviewModal]=useState(false);
    const [showReturnedStudyReasonModal, setShowReturnedStudyReasonModal] = useState(false);
    const [showReportHistoryModal, setShowReportHistoryModal] = useState(false);
    const [showGatewayStudyStatusModal, setShowGatewayStudyStatusModal] = useState(false);
    const [showEditPatientModal, setShowEditPatientModal] = useState(false);
    const [showUploadHistoryModal, setShowUploadHistoryModal] = useState(false);
    const [showUploadHistoryResponseModal, setShowUploadHistoryResponseModal] = useState(false);
    // const [showUploadHistoryDeleteConfirmModal, setShowUploadHistoryDeleteConfirmModal] = useState(false);
    const [showUploadHistoryResponseMessage, setShowUploadHistoryResponseMessage] = useState("");
    const [showEditPatientErrorModal, setShowEditPatientErrorModal] = useState(false);
    const [showEditPatientErrorMessage, setShowEditPatientErrorMessage] = useState("");
    const [showSendReportModal_, setShowSendReportModal_] = useState(false);

    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [shareStudyNotAllowed, setShareStudyNotAllowed] = useState(false);

    const [paymentStatusOfStudy, setPaymentStatusOfStudy] = useState(0);
    const [paymentMessageOfStudy, setPaymentMessageOfStudy] = useState("");
    const [showPaymentAlertModal, setShowPaymentAlertModal] = useState(false);
    const [showImageDelete , setShowImageDelete] = useState(false);

    const [showSendToPacsModal, setShowSendToPacsModal] = useState(false);
    const [showPeerReviewAssignmentModal, setShowPeerReviewAssignmentModal] = useState(false);
    const [showEvaluatorAssignmentModal, setShowEvaluatorAssignmentModal] = useState(false);
    const [showStudyAuditLogsModal, setShowStudyAuditLogsModal] = useState(false);
    const [delayHandler, setDelayHandler] = useState(null);
    const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
    const [showTypistModal, setShowTypistModal] = useState(false);

    const copyTextToClipboard = async (text) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "absolute";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    };

    const handleCopyPatientStudyDetails = async (event) => {
      event.stopPropagation();
      event.preventDefault();

      const patientStudyDetails = [
        `Patient name: ${patientName || ""}`,
        `PatientId: ${patientId || ""}`,
        ...(getEnv("REACT_APP_VDC_PLATFORM") == "true"
        ? [`OrderId: ${orderId || ""}`]
        : []),
        `Accession Number: ${study.accessionNumber || ""}`,
        `Gender: ${study.patientSex || ""} | Age: ${study.patientAge || ""} | Modality: ${study.modality?.name || ""}`,
        `Study desc: ${study.studyDescription || ""}`,
      ].join("\n");
    
      try {
        await copyTextToClipboard(patientStudyDetails);
        showToastv2(TOAST_TYPE.SUCCESS, "Patient and Study details copied");
      } catch (error) {
        console.error("Clipboard error:", error);
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
      }
    };

    const handleEditReport = () => {
      console.log("--- Setting Study Id ---",externalReportingLoading);

      setExternalReportingLoading(true);
      externalReportingModalRef.current.continuousStart();

      setStudyParentId(studyId);
      setIsExternal(true);
     
      setFirmId(props.data.row.original?.assignmentList[0]?.firmId)
      setModalityReport(props.data.row.original.modality.name);
      setOpenReportModal(true);
    }

    const checkForAnyUploadedHistory = () => {
      if(props.data.row.original?.history == null && props.data.row.original?.studyHistoryDocList?.length == 0){
          return false;
      }else{
        return true;
      }
    }
    const getStudyStatusColor = (study) => {
      return study.gatewayUploadStatus == 1
        ? "green"
        : study.gatewayUploadStatus == 2
        ? "yellow"
        : "red";
    };

    const getSubMenuForDelete= (orderStudyDeleteBlocked)=>{
      return {
        items: [
          { key: 'SubMenuDeleteStudy', text: t('study-list.actions.delete-study'), title: t('study-list.actions.delete-study'), disabled: orderStudyDeleteBlocked, className: 'study-list-action-delete', style: { '--disabled-item-color': getThemeColor("primary-color") }, onClick:() => handleDeleteStudy() },
          { key: 'SubMenuDeleteImage', text: t('study-list.actions.delete-study-image'), title: t('study-list.actions.delete-study-image') , onClick:() => handleImageDeleteStudy() },
        ],
      };
    }

    const getReturnedStudyCount = (study_id) => {
      let count = 0;
      if (returnedReasonCount.length > 0) {
        count = returnedReasonCount.filter((ele, index) => {
          return ele.studyId == study_id;
        })[0]?.noOfReasons;
      }
      return count > 0 ? count : null;
    };
    const mapChoiceToKey = (choice) => {
      // 'NONE' -> 1, 'MEDICAL' -> 2 (default), 'NON_MEDICAL' -> 3
      if (choice === 'NONE') return 1;
      if (choice === 'NON_MEDICAL') return 3;
      return 2; // MEDICAL
    };

const updateEmergency = useCallback(async (choice) => {
  try {
    setLoaderRunning(true);
    ref.current.continuousStart();

    const emergencyKey = mapChoiceToKey(choice);
    const res = await updateStudyEmergencyOnlyAPI(studyId, emergencyKey);

    setLoaderRunning(false);
    ref.current.complete();

    if (res?.status === 200 && res?.data?.result === "SUCCESS") {
      setDataQueryState(prev => {
        const next = { ...prev };
        const i = props.data.row.index;
        const isNone = emergencyKey === 1;
        next.data.rows[i].emergency = !isNone;
        next.data.rows[i].nonMedicalEmergency = emergencyKey === 3;
        return next;
      });
      showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.update-success"));
    } else {
      throw new Error("SAVE failed");
    }
  } catch (_) {
    setLoaderRunning(false);
    ref.current.complete();
    setAlertSuccessModal(prev => ({
      ...prev,
      show: true,
      heading: "Error",
      isError: false,
      isSuccess: false,
      isWarning: true,
      description: t("string-literals.failed-message"),
    }));
  } finally {
    setShowSetEmergencyModal(false);
  }
}, [studyId, props.data.row.index]);

    const menuPropsItems = () =>{
      let items = [];
      const isReportedTab = REPORTED_TABS_NAME.includes(props.listTabId) ||
        REPORTED_SUBTABS_ID.includes(props.listTabId) ||
        props.subTabId === 'resubmission';
      if(props.data.row.depth === 0 && !(roles[0] == USERTYPES.RADIOLOGIST && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE))){
        items.push({
          key: 'TAT',
           iconProps: {iconName: 'TATIcon',className: 'study-list-action-icon-class'},
          text: t("study-list.actions.tat"),
          onClick:() => handleTAT(),
        });
      }
      if(props.data.row.depth === 0 && (roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.RADIOLOGIST) 
        && study.reportDoneStatus === 2 
        && getEnv("REACT_APP_VDC_PLATFORM") == "true"
        && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE || props.tabId == TAB_NAME.EVALUATIONASSIGNED || props.tabId == TAB_NAME.EVALUATIONCOMPLETE))
      {
        items.push({
          key: 'PeerReview',
           iconProps: {iconName: 'PeerReviewTimeLine',className: 'study-list-action-icon-class'},
          text: t("peer-review.title"),
          onClick:() => handlePeerReview(),
        });
      }
      if((props.tabId != TAB_NAME.CLOSED) && (!isBucketManagement || 
        (!RESTRICTED_STORAGE_TYPES.includes(study.storageType) && study.storageType !== storageType.COLD_STORAGE))){
        items.push({
          key: 'ShareStudyLink',
          iconProps: { iconName: 'studyListShareStudy', className: 'study-list-action-icon-class'},
          text: t("share-study.title"),
          onClick:() => handleShareStudyLink(),
        });
      }
      if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMTECHNICIAN){
        // items.push({
        //   key: 'uploadHistory',
        //   iconProps: {iconName: checkForAnyUploadedHistory()?'UploadedHistoryIcon':'UploadHistoryIcon',className: 'study-list-action-icon-class'
        // },
        //   text: 'Upload History',
        //   onClick:() => {showUploadHistoryModalFunc()}
        // });

        if (isActiveData && !contextSwitchUser && 
    (
      // For non-reported tabs
      !isReportedTab || 
      // For reported tabs (including subtabs), allow FirmAdmin and Supervisor
      (
        isReportedTab && 
        (roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN) &&
        (editPatientAccess === true || 
         (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == "true"))
      )||
      // For VDC/BVP platforms with reported tabs
      (
        (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == "true") && 
        (
          roles[0] === USERTYPES.ADMIN ||
          // (!isReportedTab && (roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN))
          (roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN)
        )
      )
    ) && 
    (
      // For VDC/BVP platforms
      (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == "true")
        ? (
            roles[0] === USERTYPES.SUPERVISOR || 
            roles[0] === USERTYPES.ADMIN || 
            roles[0] === USERTYPES.FIRMADMIN ||
            (roles[0] === USERTYPES.FIRMDOCTOR && allowStudyEdit) ||
            (roles[0] === USERTYPES.FIRMTECHNICIAN && allowStudyEdit) || 
            study.reportDoneStatus < 2
          )
        : (
            // For non-VDC/BVP platforms
            study.reportDoneStatus != 2 || 
            roles[0] === USERTYPES.SUPERVISOR || 
            roles[0] === USERTYPES.FIRMADMIN
          )
    ) && 
    ( !isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType)) && 
    props.data.row.depth === 0 && 
    !((roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN) && !allowStudyEdit)){
          items.push({
            key: 'editPatient',
            iconProps: {iconName: 'EditPatientIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.edit-patient"),
            onClick:() => {showEditPatientModalFunc()},
          });
        }
        if(isActiveData && !contextSwitchUser 
          && (props.data.row.depth === 0 && roles[0] == USERTYPES.SUPERVISOR && (study.assignmentList[0].closed == 0 && study.reportDoneStatus != 2)) 
          && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))
          ){
          items.push({
            key: 'CloseStudy',
            iconProps: { iconName: 'CloseStudyIcon' ,className: 'study-list-action-icon-class'},
            text: t("study-list.actions.close-study"),
            onClick: () => handleCloseStudy(),
          });
        }
        if(isActiveData && !contextSwitchUser &&( props.data.row.depth === 0 && roles[0] == USERTYPES.SUPERVISOR && (study.assignmentList[0].closed > 0 && study.reportDoneStatus != 2))
          && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
          items.push({
            key: 'RevertCloseStudy',
            iconProps: { iconName: 'RevertCloseStudyIcon',className: 'study-list-action-icon-class' },
            text: t("study-list.actions.revert-close-study"),
            onClick: () => handleRevertCloseStudyModal(),
          });
        }
      }
      if(roles[0] == USERTYPES.RADIOLOGIST){
        // items.push({
        //   key: 'uploadHistory',
        //   iconProps: {iconName: 'FilePDB',className: 'study-list-action-icon-class',
        //   style: {color:checkForAnyUploadedHistory()?'#ff48a0':'#C1C1C1'}
        // },
        //   text: 'View History',
        //   onClick:() => {showUploadHistoryModalFunc()}
        // });
      }
      if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR && String(allowDeleteStudy).toLowerCase() === 'true'){
        const orderStudyDeleteBlocked = roles[0] != USERTYPES.ADMIN && study.clientBillingStudy && !(orderStudyDeleteEnabledFirmIds || []).includes(study.sourceFirmId);
        if((roles[0] == USERTYPES.ADMIN || (roles[0] == USERTYPES.SUPERVISOR && String(allowDeleteStudy).toLowerCase() === 'true'))&& ((study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null) || study.assignmentList[0].firmName == 'firsthospital')){
          if(study.clientBillingStudy && study.noOfImages > 0 ){
            items.push({
              key: 'DeleteStudy',
              subMenuProps: getSubMenuForDelete(orderStudyDeleteBlocked),
              iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
              text: t("study-list.actions.delete-study"),
              title: t("study-list.actions.delete-study"),
              // onClick:() => handleDeleteStudy(),

            });
          }else{
            items.push({
              key: 'DeleteStudy',
              iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
              text: t("study-list.actions.delete-study"),
              title: t("study-list.actions.delete-study"),
              disabled: orderStudyDeleteBlocked, className: 'study-list-action-delete', style: { '--disabled-item-color': getThemeColor("primary-color") },
              onClick:() => handleDeleteStudy(),
            });
          }
        } 
        else if(roles[0] == USERTYPES.ADMIN && ((study.reportDoneStatus > 0 || study.assignmentList[0].providerId != null) && study.assignmentList[0].firmName != 'firsthospital')){
          // items.push({
          //   key: 'DeleteStudy',
          //   //icon should be grey (disabled)
          //   iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
          //   text: 'Delete Study',
          //   title: 'Delete Study',
          // });
        }
        else if((roles[0] == USERTYPES.FIRMADMIN || (roles[0] == USERTYPES.SUPERVISOR && String(allowDeleteStudy).toLowerCase() === 'true')) && (((enterprise || (!enterprise && (study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)))) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null) || study.assignmentList[0].firmName == 'firsthospital')){
        if(props.data.row.depth === 0){
            if(study.clientBillingStudy && study.noOfImages > 0 ){
              items.push({
                key: 'DeleteStudy',
                subMenuProps: getSubMenuForDelete(orderStudyDeleteBlocked),
                iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
                text: t("study-list.actions.delete-study"),
                title: t("study-list.actions.delete-study"),
                // onClick:() => handleDeleteStudy(),
  
              });
            }else{
              items.push({
                key: 'DeleteStudy',
                iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
                text: t("study-list.actions.delete-study"),
                title: t("study-list.actions.delete-study"),
                disabled: orderStudyDeleteBlocked, className: 'study-list-action-delete', style: { '--disabled-item-color': getThemeColor("primary-color") },
                onClick:() => handleDeleteStudy(),

              });
            }
           
          }
          
        } 
        else if(roles[0] == USERTYPES.FIRMADMIN && ((enterprise || (!enterprise && (study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)))) && study.reportDoneStatus > 0 || study.assignmentList[0].providerId != null) && study.assignmentList[0].firmName != 'firsthospital'){
          // items.push({
          //   key: 'DeleteStudy',
          //   //icon should be grey (disabled)
          //   iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
          //   text: 'Delete Study',
          //   title: 'Delete Study',
          // });
          if(props.data.row.depth === 0 && study.clientBillingStudy && study.noOfImages > 0 && study.reportDoneStatus == 1){
            items.push({
              key: 'DeleteImage',
              iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
              text: t("study-list.actions.delete-study-image"),
              title: t("study-list.actions.delete-study-image"),
              onClick:() => handleImageDeleteStudy(),
            });
          }
        }
        if ((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN) && studyListModalAuditEnabled) {
          items.push({
            key: 'ViewAuditLogs',
            iconProps: { iconName: 'Clock', className: 'study-list-action-icon-class', style : {color : getThemeColor("icon-color")}  },
            text: t("study-list.actions.view-audit-logs"),
            title: t("study-list.actions.view-audit-logs"),
            onClick: () => showStudyAuditLogsModalFunc(),
          });
        }
        if(isActiveData && study.storageType == 1 && study.noOfImages > 0 &&  props.data.row.depth === 0 && (( REINFERECE_ALLOWED_MODALITY.includes(study.modality.name) && study.triageXRAYStudies) || study.aiReinference) && study.reportDoneStatus != 2 && !study.genkiStudy){
          items.push({
            key: 'Reinference',
            iconProps: {iconName: 'ReinferenceIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.reinference"),
            onClick:() => handleReInferenceStudy(),
          });
        }        
        else if(props.data.row.depth === 0 && (study.modality.name != 'DX' && study.modality.name != 'CR' && study.modality.name != 'RG') || study.reportDoneStatus == 2){
          // items.push({
          //   key: 'Reinference',
          //   iconProps: {iconName: 'ReinferenceIcon',className: 'study-list-action-icon-class'},
          //   text: 'Reinference',
          //   //disabled , icon grey
          // });
        }
        if(isActiveData && !contextSwitchUser && ( study.assignmentList[0].closed == 0 && study.reportDoneStatus != 2 && props.data.row.depth === 0)
          && roles[0] != USERTYPES.SUPERVISOR
          && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
          items.push({
            key: 'CloseStudy',
            iconProps: { iconName: 'CloseStudyIcon',className: 'study-list-action-icon-class' },
            text: t("study-list.actions.close-study"),
            onClick: () => handleCloseStudy(),
          });
        }
        if(isActiveData && props.data.row.depth === 0 && study.assignmentList[0].closed > 0 && study.reportDoneStatus != 2 && (study.assignmentList[0].closed == study.assignmentList[0].firmId)
          && roles[0] != USERTYPES.SUPERVISOR
          && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
          items.push({
            key: 'RevertCloseStudy',
            iconProps: { iconName: 'RevertCloseStudyIcon',className: 'study-list-action-icon-class' },
            text: t("study-list.actions.revert-close-study"),
            onClick: () => handleRevertCloseStudyModal(),
          });
        }
      }
      if(roles[0] == USERTYPES.RADIOLOGIST && isActiveData && props.data.row.depth === 0
        && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
        if (!study.libraryStudy) {
          items.push({
            key: 'AddToLibrary',
            iconProps: {iconName: 'AddToLibraryIcon', className: 'study-list-action-icon-class'},
            text: t("study-list.actions.add-to-library"),
            onClick: () => handleAddToLibraryThenChoose(),
          });
        } else {
          items.push({
            key: 'RemoveFromLibrary',
            iconProps: {iconName: 'RemoveFromLibraryIcon', className: 'study-list-action-icon-class'},
            text: t("study-list.actions.remove-from-library"),
            onClick: () => handleRemoveFromLibrary(),
          });
          items.push({
            key: 'EditLibrary',
            iconProps: {iconName: 'EditLibraryIcon', className: 'study-list-action-icon-class'},
            text: t("study-list.actions.edit-library"),
            onClick: () => {
              setSkipLibraryTags(false);
              setShowLibraryModal(true);
            },
          });
        }
      }
      if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMTECHNICIAN || roles[0] == USERTYPES.FIRMDOCTOR ){

        if(isActiveData && study.assignmentList[0].closed != 0 && study.reportDoneStatus != 2 && props.tabId == 'closed' 
          && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType)) && props.data.row.depth === 0 ){
          items.push({
            key: 'closeStudyReason',
            iconProps: {iconName: 'ReturnStudyIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.close-study-reason"),
            onClick:() => {
              setAlertSuccessModal(()=>{
                const newItem = {...alertSuccessModal};
                newItem.show = true;
                newItem.heading = "Closing Reasons";
                newItem.isError = false;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = study.assignmentList[0].closingReason;
                return newItem;
              });
            },
          });
        }
        // if(getReturnedStudyCount(props.data.row.original.id) != null  && props.data.row.depth === 0){
        //   items.push({
        //     key: 'returnStudyReason',
        //     iconProps: {iconName: 'ReturnStudyIcon',className: 'study-list-action-icon-class'},
        //     text: t("study-list.actions.returned-reason"),
        //     onClick:() => handleReturnedReason()
        //   });
        // }
        if(roles[0] != USERTYPES.TYPIST && roles[0] != USERTYPES.FIRMTECHNICIAN && roles[0] != USERTYPES.FIRMDOCTOR){

          items.push({
            key: 'viewReportHistory',
            iconProps: {iconName: 'ReportHistoryIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.report-history"),
            onClick:() => handleViewReportHistory(),
          });
        }
      }
      if(roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.FIRMTECHNICIAN){
          if(study.wordFilePath != null && study.wordFilePath != ""){
            items.push({
              key: 'viewReportHistory',
              iconProps: {iconName: 'ReportHistoryIcon',className: 'study-list-action-icon-class'},
              text: t("study-list.actions.report-history"),
              onClick:() => handleViewReportHistory(false),
            });
          }
       }
      // items.push({
      //   key: 'reportEdit',
      //   iconProps: {iconName: 'ReportingIcon',className: 'study-list-action-icon-class'},
      //   text: 'Reporting',
      //   onClick:() => handleEditReport()
      // });
      if(study.reportDoneStatus === 2 && getEnv("REACT_APP_ENABLE_SHARE_REPORT_BUTTON") == "true" || getEnv("REACT_APP_ENABLE_SHARE_REPORT_BUTTON") == true){
        items.push({
          key: 'SendReport',
          // iconProps: {iconName: 'MailIcon',className: 'study-list-action-icon-class'},
          iconProps: {iconName: study.assignmentList[0]?.notificationSent?'UnSendMailIcon':'MailIcon',className: 'study-list-action-icon-class'},
          text: t("heading.send-report"),
          onClick:() => handleSendReport(),
          // disabled: !isActiveData
        });
      }
      // and study.reportDoneStatus == 2 and study.limsSendEligible == true}
      if(study.reportDoneStatus === 2 && study.storageType == 1 && study.limsSendEligible == true && !(roles[0] == USERTYPES.RADIOLOGIST && study.peerReviewAssignment && study.peerReviewAssignment.reviewerId == userId)){
        items.push({
          key: 'sendReportoLims',
          // iconProps: {iconName: 'MailIcon',className: 'study-list-action-icon-class'},
          iconProps: {iconName: 'OpenFile',className: 'study-list-action-icon-class', style : {color : getThemeColor("icon-color")}},
          text: t("heading.send-report-lims"),
          onClick:() => handleSendReportLIMS(),
          // disabled: !isActiveData
        });
      }

       if(study.reportDoneStatus === 2 && study.storageType == 1 && getEnv("REACT_APP_VDC_PLATFORM") == "false" && study.hl7EnabledFirm == true && !(roles[0] == USERTYPES.RADIOLOGIST )){
        items.push({
          key: 'sendHl7FReport',
          // iconProps: {iconName: 'MailIcon',className: 'study-list-action-icon-class'},
          iconProps: {iconName: 'OpenFile',className: 'study-list-action-icon-class', style : {color : getThemeColor("icon-color")}},
          text: t("heading.send-hl7"),
          onClick:() => handleSendHl7(),
          // disabled: !isActiveData
        });
      }
      if(!(roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.TYPIST) && study.yoloStudy  
       && study.aiProcessed == 1
       && getEnv("REACT_APP_VDC_PLATFORM") == "false")
      {
          items.push({
          key: 'setAIReport',
          iconProps: {iconName: 'ReplyAll',className: 'study-list-action-icon-class', style : {color : getThemeColor("icon-color")}},
          text: t("heading.send-ai-report"),
          onClick:() => handleSendAIReport(),
        });
      }

      if(
        (roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST
        || roles[0] == USERTYPES.SUPERVISOR) &&
         (study.reportDoneStatus == 1 || study.reportDoneStatus == 2)){
          // items.push({
          //   key: 'Preview',
          //   iconProps: { iconName: 'PreviewStudyListIcon',className: 'study-list-action-icon-class' },
          //   text: 'Preview Report',
          //   onClick: () => handlePreviewReport(studyId),
          // });
        }

        if(study.reportDoneStatus == 2 && (study.allowDownloadReport || roles[0] == USERTYPES.ADMIN)){
            // items.push({
            //   key: 'DownloadReport',
            //   iconProps: {iconName:'DownloadReportIcon',className: 'study-list-action-icon-class'},
            //   subMenuProps: {
            //     items: [
            //       { key: 'docx', text: 'DocX',onClick: ()=>{downloadReport("docx",studyId)}},
            //       { key: 'docxWithKeyImage',text: 'DocX with Key Image',onClick: ()=>{downloadReport("docxwithkeyimage",studyId)}},
            //       { key: 'doc', text: 'Doc',onClick: ()=>{downloadReport("doc",studyId)}},
            //       { key: 'pdf', text: 'PDF',onClick: ()=>{downloadReport("pdf",studyId)}},
            //       { key: 'pdfWithImage', text: 'PDF with Image',onClick: ()=>{downloadReport("pdfwithimage",studyId)}},
            //       { key: 'pdfWithKeyImage', text: 'PDF with Key Image',onClick: ()=>{downloadReport("pdfwithkeyimage",studyId)}},
            //     ],
            //   },
            //   text: 'Download Report',
            // });
          }

       if(isActiveData && roles[0] == USERTYPES.RADIOLOGIST && (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2) && (study.reportDoneStatus == 0 || study.reportDoneStatus ==1 )
          && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
        items.push({
          key: 'Typist',
          // iconProps: {iconName: 'MailIcon',className: 'study-list-action-icon-class'},
          iconProps: {iconName: 'KeyboardClassic',className: 'study-list-action-icon-class'},
          text: t("heading.typist"),
          onClick:() => {setShowTypistModal(true)},
        })
       }
          
          if(isActiveData && (roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN)
            && study.extFirmAssigned
            && study.assignmentList[0].closed == 0
            && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))
            && props.data.row.depth === 0
          ){
            items.push({
              key: 'externalDicomPush',
              iconProps: { iconName: 'NavigateExternalInline', className: 'study-list-action-icon-class',style : {color : getThemeColor("icon-color")}},
              text: t("study-list.actions.ext-dicom-push"),
              onClick: () => handleExternalDicomPush(),
            });
          }
          if(isActiveData && study.storageType == 1 && routeToNodeEnabled && study.noOfImages > 0 && ( roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMTECHNICIAN || (
          roles[0] == USERTYPES.RADIOLOGIST && study.assignmentList[0].providerId != null && study.assignmentList[0].providerId.startsWith("R") && (userId == study.assignmentList[0].providerId.substring(1))))
           && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
            items.push({
              key: 'SendToPacs',
              iconProps: { iconName: 'Share', className: 'study-list-action-icon-class'},
              text: t("study-list.actions.send-to-pacs"),
              onClick: () => handleSendToPacs(studyId),
            });
          }
          if( study.gatewayUploadStatus != null ){
            items.push({
              key: 'View Gateway Status',
              iconProps: { iconName: 'SkypeCircleArrow', className: 'study-list-action-icon-class', style : {color : getStudyStatusColor(study)}},
              text: t("study-list.actions.view-gateway-status"),
              onClick: () => handleShowGatewaStudyStatus(studyId),
            });
          }

          if((roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR) 
            && study.reportDoneStatus === 2 
            && getEnv("REACT_APP_VDC_PLATFORM") == "true"
            && peerReviewAdmin && (!study.peerReviewAssignment || study.peerReviewAssignment.reviewStatus == 1)
            && (props.tabId == TAB_NAME.REVIEWASSIGNED || REPORTED_TABS_NAME.includes(props.tabId))
            ){
            items.push({
              key: 'peerReviewAssignment',
              // iconProps: {iconName: 'MailIcon',className: 'study-list-action-icon-class'},
              iconProps: {iconName: 'PeerReviewAssignmentIcon',className: 'study-list-action-icon-class', style : {color : getThemeColor("icon-color")}},
              text: t("study-list.actions.peer-review-assignment"),
              onClick:() => handlePeerReviewAssignment(studyId),
              // disabled: !isActiveData
            });
          }
      
          if((roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR) 
            && study.reportDoneStatus === 2 
            && getEnv("REACT_APP_VDC_PLATFORM") == "true"
            && peerReviewAdmin && study.peerReviewAssignment && study.peerReviewAssignment.reviewStatus == 2
            && props.tabId == TAB_NAME.REVIEWCOMPLETE
            ){
            items.push({
              key: 'evaluatorAssignment',
              // iconProps: {iconName: 'MailIcon',className: 'study-list-action-icon-class'},
              iconProps: {iconName: 'PeerReviewEvaluatorIcon',className: 'study-list-action-icon-class', style : {color : getThemeColor("icon-color")}},
              text: t("study-list.actions.evaluator-assignment"),
              onClick:() => handleEvaluatorAssignment(studyId),
              // disabled: !isActiveData
            });
          }

          // ---- Emergency actions
          if((roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN) && study.reportDoneStatus != 2 ){
            if(isActiveData && props.data.row.depth === 0 && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
          const hasEmergency = !!(study.emergency || study.nonMedicalEmergency);

          if (hasEmergency) {
            items.push({
              key: 'RemoveEmergency',
              iconProps: { iconName: 'Cancel', className: 'study-list-action-icon-class',
              style: { color: getThemeColor('icon-color') }, },
              text: 'Mark as No Emergency',
              onClick: () => updateEmergency('NONE'),
            });
          } else {
            items.push({
              key: 'SetEmergency',
              iconProps: { iconName: 'WarningSolid', className: 'study-list-action-icon-class',style: { color: getThemeColor('icon-color') }, },
              text: 'Set Emergency',
              //onClick: () => { setEmergencyChoice('MEDICAL'); setShowEmergencyDialog(true); },
              onClick: () => setShowSetEmergencyModal(true),            });
          }
        }
      }

      return items;
    }

    const getActionMenuItems = () => {
      const items = menuPropsItems();
      if (isGlobalSearchResultsTab(props.listTabId) || selectedValue === STUDY_SEARCH_RESULTS_ID) {
        return filterActionMenuForGlobalSearch(items, props.tabId);
      }
      return items;
    };


    const menuProps = {
        shouldFocusOnMount: true,
        items:getActionMenuItems(),
      };

  const showEditPatientModalFunc =()=> {//pass patientId as 
    setShowEditPatientModal(true);
  }

  const showStudyAuditLogsModalFunc = () => {
    setShowStudyAuditLogsModal(true);
  };

  const showUploadHistoryModalFunc =()=> {//pass patientId as 
    setShowUploadHistoryModal(true);
  }

  const handleRevertCloseStudyModal = () =>{
    if(showRevertConfirmModal){
      setShowRevertConfirmModal(false);
      setShowConfirmModal(false);
    }else{
      setShowRevertConfirmModal(true);
      setShowConfirmModal(true);
    }
  }

  const handleRevertCloseStudyApiFunc = async() =>{
    setShowRevertConfirmModal(false);
    setShowConfirmModal(false);
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await RevertCloseStudyApi(studyId, props.data.row.original.assignmentList[0].id);
    if(response.data.message === "database_error"){
      // setShowRevertStudyResponseMsg(t("confirm-message.revert-closeStudy-database-error-message"));
      setLoaderRunning(false);
      ref.current.complete();
      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("confirm-message.revert-closeStudy-database-error-message");
        return newItem;
      });
       

      
    }else{
      // setShowRevertStudyResponseMsg(response.data.message);
      setLoaderRunning(false);
      ref.current.complete();
      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = response.data.message;
        return newItem;
      });

      setRefreshRequired(()=>{
        const newItem = {...refreshRequired};
        newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
        return newItem;
      });

    let newData = dataQueryState?.data?.rows.filter(
      (row) => row.id !== props.data.row.original.id
    );
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows = newData;
      return newValue;
    });
    }
    setShowRevertReponseModal(true);
    setShowConfirmModal(true);
  }

  const handleDeleteStudy = () =>{
    console.log("enter in delete");
    setShowConfirmModal(true);
    setShowDeleteModal(true);
    setShowImageDelete(false);
  }
  const handleImageDeleteStudy = () =>{
    console.log("enter in image delete");
    setShowConfirmModal(true);
    setShowDeleteModal(false);
    setShowImageDelete(true);
  }

  const handleReInferenceStudy = async() =>{
    const response = await ReInferenceApi(studyId);
    console.log(response);
    //handle alert acc. to response -> pending
    if(response.data.result == "SUCCESS"){
    setShowConfirmModal(true);
    setAlertSuccessModal(()=>{
      const newItem = {...alertSuccessModal};
      newItem.show = true;
      newItem.heading = "Alert";
      newItem.isError = false;
      newItem.isSuccess = false;
      newItem.isWarning = true;
      newItem.description = t("confirm-message.reInference-message");
      return newItem;
    });
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState
      };
      newValue.data.rows[props.data.row.index].aiProcessed = 2;
      newValue.data.rows[props.data.row.index].aiEmergencyMax = -1;
      newValue.data.rows[props.data.row.index].attention = false;
      newValue.data.rows[props.data.row.index].emergency = false;
      newValue.data.rows[props.data.row.index].nonMedicalEmergency = false;
      newValue.data.rows[props.data.row.index].studyPredictionList = [];
      newValue.data.rows[props.data.row.index].studyClassificationPredictionList = [];
      return newValue;
    });
    }else{
      if(response?.status === 429){
        setAlertSuccessModal(()=>{
          const newItem = {...alertSuccessModal};
          newItem.show = true;
          newItem.heading = "Error";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description =  response?.data?.message;
          return newItem;
        });
        return;
      }
      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description =  t("string-literals.failed-message");
        return newItem;
      });
    }
    //setShowReInferenceModal(true);

   

  }

  const handleRemoveRowForDeletedStudy = () => {
    let newData = dataQueryState?.data?.rows.filter(
      (row) => row.id != studyId
    );
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows = newData;
      return newValue;
    });
  }

  const deleteStudyFunc = async() =>{
    var deleteImageCheck = showImageDelete;
    setShowImageDelete(false);
    setShowDeleteModal(false);
    setShowConfirmModal(false);
    const response = await deleteStudyApi(studyId, deleteImageCheck);
    console.log(response);
    //handle alert acc. to response -> pending
    if(response.data.result == "FAILURE"){
      //setShowDeleteResponseMsg(response.data.message == "database_error"? t("confirm-message.delete-database-error-message") : response.data.message);
      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = response.data.message == "database_error"? t("confirm-message.delete-database-error-message") : response.data.message;
        return newItem;
      });
    }else{
      if(!deleteImageCheck){
        handleRemoveRowForDeletedStudy();
      }
      else{
        setRefreshRequired(()=>{
          const newItem = {...refreshRequired};
          newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
          newItem[TAB_NAME.SAVED].alreadyLoaded = false;
          newItem[TAB_NAME.CLOSED].alreadyLoaded = false;
          console.log(newItem);
          return newItem;
        });
      }

      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description =deleteImageCheck== true? t("confirm-message.delete-image-success-message"): t("confirm-message.delete-success-message");
        return newItem;
      });
      // setShowDeleteResponseMsg(t("confirm-message.delete-success-message"))
    }
    //setShowDeleteResponseModal(true);
    //setShowConfirmModal(true);
  }

  const handleCloseStudy = () =>{
    setShowConfirmModal(true);
    setShowCloseStudyModal(true);
  }

  const handleAddToLibrary = async() =>{
    const response = await addToLibraryApi(studyId);
    console.log("---- Library added ----",response);
    if(response.data.result == "SUCCESS"){
      // setAlertSuccessModal(()=>{
      //   const newItem = {...alertSuccessModal};
      //   newItem.show = true;
      //   newItem.heading = "Alert";
      //   newItem.isError = false;
      //   newItem.isSuccess = false;
      //   newItem.isWarning = true;
      //   newItem.description = response.data.message;
      //   return newItem;
      // });

      showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.add-to-library-success"));

      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState
        };
        newValue.data.rows[props.data.row.index].libraryStudy = true;      
        return newValue;
      });
      setTimeout(()=>{
        setRefreshRequired(()=>{
          const newItem = {...refreshRequired};
          newItem[TAB_NAME.LIBRARY].alreadyLoaded = false;
          return newItem;
        });
      },10);
      

      return true;
    }else{
      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
      return false;
    }
    

    // setShowLibraryResponseMsg(response.data.message)
    // setShowConfirmModal(true);
    // setShowLibraryResponseModal(true);   
    //dataQueryState.refetch();
  }

  const handleRemoveFromLibrary = async() =>{
    const response = await removeFromLibraryApi(studyId);

    if(response.data.result == "SUCCESS"){
      // setAlertSuccessModal(()=>{
      //   const newItem = {...alertSuccessModal};
      //   newItem.show = true;
      //   newItem.heading = "Alert";
      //   newItem.isError = false;
      //   newItem.isSuccess = false;
      //   newItem.isWarning = true;
      //   newItem.description = response.data.message;
      //   return newItem;
      // });
      showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.removed-to-library-success"));
      if(props.tabId == TAB_NAME.LIBRARY){

        setTimeout(()=>{
          setRefreshRequired(()=>{
            const newItem = {...refreshRequired};
            newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
            console.log(newItem);
            return newItem;
          });
        },10);  

        let newData = dataQueryState?.data?.rows.filter(
          (row) => row.id !== studyId
        );
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          newValue.data.rows = newData;
          return newValue;
        });    
      }else{
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState
          };
          newValue.data.rows[props.data.row.index].libraryStudy = false;      
          return newValue;
        });
      }
      


    }else{
      setAlertSuccessModal(()=>{
        const newItem = {...alertSuccessModal};
        newItem.show = true;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }

  const handleAddToLibraryThenChoose = async () => {
    const added = await handleAddToLibrary();
    if (!added) return;
    setSkipLibraryTags(true);
    setShowLibraryModal(true);
  };

  const handleLibrarySave = async (tagIds) => {
    if (skipLibraryTags && tagIds.length === 0) {
      setShowLibraryModal(false);
      return;
    }
    let response;
    try {
      response = await saveLibraryStudyTagsApi(studyId, tagIds);
    } catch (e) {
      response = null;
    }
    if(response && response.data && response.data.result == "SUCCESS"){
      const tags = response.data.data && response.data.data.tags ? response.data.data.tags : [];
      setDataQueryState(() => {
        const newValue = { ...dataQueryState };
        if (newValue.data && newValue.data.rows && newValue.data.rows[props.data.row.index]) {
          newValue.data.rows[props.data.row.index].libraryTags = tags;
        }
        return newValue;
      });
      setTimeout(() => {
        setRefreshRequired(() => {
          const newItem = { ...refreshRequired };
          newItem[TAB_NAME.LIBRARY].alreadyLoaded = false;
          return newItem;
        });
      }, 10);
      setShowLibraryModal(false);
      showToastv2(TOAST_TYPE.SUCCESS, t("study-list.library-tag.tags-saved"));
    }else{
      showToastv2(TOAST_TYPE.ERROR, (response && response.data && response.data.message) || t("string-literals.error-msg"));
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const handleShareStudyLink = async() =>{
    
    if(study.storageType === STORAGE_TYPE.COLD_STORAGE) {
      setShareStudyNotAllowed(true);
      return;
    } 

      let studyId = props.data.row.original.id;
      const response = await getPaymentStatusOfStudy(studyId);
      if(response.data.result === "SUCCESS"){
        let status = response.data.data;
        if(status == VDCLIMS.PaymentStatusCodes.PAID){
          setShowShareStudyLinkModal(true);
        }else{
          setShowModal(() => {
            const newItem = { ...showModal };
            newItem.show = true;
            newItem.type = MODAL_TYPE.ALERT_MODAL;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = status == VDCLIMS.PaymentStatusCodes.DUE
            ? t("payment-status.payment-due-message")
            : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      }else{
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("payment-status.payment-error-message");
          return newItem;
        });
      }
  }
  const handleTAT = async() =>{
    console.log("tat");
    // const response = await showStatusAPI(studyId);
    // console.log(response);
    setShowTATTimelineModal(true);
  }

  const handlePeerReview = async() =>{
    setShowPeerReviewModal(true);
  }

  const handleDeleteSuccessCloseModal = () =>{
    if(showDeleteModal){
      setShowDeleteModal(false);
    }
    if(showDeleteResponseModal){
      setShowDeleteResponseModal(false);
    }
    setShowConfirmModal(false);
  }

  const handleReInferenceCloseModal = () =>{
    setShowReInferenceModal(false);
    setShowConfirmModal(false);
  }

  const handleCloseStudyResponseCloseModal = () =>{
    setShowCloseStudyResponseModal(false);
    setShowConfirmModal(false);
  }

  const handleCloseRevertResponseModal = () =>{
    setShowRevertReponseModal(false);
    setShowConfirmModal(false);
  }

  const handleCloseLibraryResponseModal = () =>{
    setShowLibraryResponseModal(false);
    setShowConfirmModal(false);
  }

  const handleCloseStudySharingFailureModal = () =>{
    setShowStudysharingResponse(false);
    setShowConfirmModal(false);
  }

  const handleReturnedReason = () =>{
    setShowReturnedStudyReasonModal(true);
    setShowReturnedStudyReasonModal({studyId:null,show:true});
    
  }

  const handleViewReportHistory = () => {
    setShowReportHistoryModal(true);
  }

  const handleExternalDicomPush = async () => {
    try {
      let studyId = props.data.row.original.id;
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await externalDicomPushApi(studyId);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.SUCCESS, "Study re-pushed to external firm successfully");
      } else if (response.data.result === "FAILURE") {
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.ERROR, response.data.message || "Failed to re push study to external firm");
      } else {
        setLoaderRunning(false);
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Error";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
    } catch (e) {
      setLoaderRunning(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const handleSendToPacs = () => {
    setShowSendToPacsModal(true);
  }

  const handlePeerReviewAssignment = () => {
    setShowPeerReviewAssignmentModal(true);
  }

  const handleEvaluatorAssignment = () => {
    setShowEvaluatorAssignmentModal(true);
  }

  const handleShowGatewaStudyStatus = ()=>{
    setShowGatewayStudyStatusModal(true);
  }

  const handleCloseUploadHistoryResponseModal = () =>{
    setShowUploadHistoryResponseModal(false);
    setShowConfirmModal(false);
  }

  const handleCloseEditPatientErrorModal = () =>{
    setShowEditPatientErrorModal(false);
    setShowConfirmModal(false);
  }
  
  const handleSendReportLIMS = async () => {
    // send report via attachment or/and send report via link
    try {
      let studyId = props.data.row.original.id;
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await sendReportToLIMS(studyId);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
          setShowModal(() => {
            const newItem = { ...showModal };
            newItem.show = true;
            newItem.type = MODAL_TYPE.ALERT_MODAL;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = response?.data?.message
            return newItem;
          });
      }
       else {
        setLoaderRunning(false);
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Error";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
    } catch (e) {
      setLoaderRunning(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const handleSendHl7 = async () => {
    // send Hl7
    try {
      let studyId = props.data.row.original.id;
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await sendHl7(studyId);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
          setShowModal(() => {
            const newItem = { ...showModal };
            newItem.show = true;
            newItem.type = MODAL_TYPE.ALERT_MODAL;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = response?.data?.message
            return newItem;
          });
      }
       else {
        setLoaderRunning(false);
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Error";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
    } catch (e) {
      setLoaderRunning(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const handleSendAIReport = async () => {
    try {
      let studyId = props.data.row.original.id;
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await sendAIReport(studyId);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
          setShowModal(() => {
            const newItem = { ...showModal };
            newItem.show = true;
            newItem.type = MODAL_TYPE.ALERT_MODAL;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = response?.data?.message
            return newItem;
          });
      }
       else {
        setLoaderRunning(false);
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Error";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
    } catch (e) {
      setLoaderRunning(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const handleSendReport = async() =>{
    // send report via attachment or/and send report via link

    let studyId = props.data.row.original.id;
    const response = await getPaymentStatusOfStudy(studyId);
    if(response.data.result === "SUCCESS"){
      let status = response.data.data;
      if(status == VDCLIMS.PaymentStatusCodes.PAID){
        setShowSendReportModal_(true);
      }else{
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = status == VDCLIMS.PaymentStatusCodes.DUE
          ? t("payment-status.payment-due-message")
          : t("payment-status.payment-error-message");
          return newItem;
        });
      }
    }else{
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("payment-status.payment-error-message");
        return newItem;
      });
    }

  }

  const handleTypistButton= async()=>{
    let studyId = props.data.row.original.id;
    const response = await getPaymentStatusOfStudy(studyId); 
  }

  // const handlePaymentAlertModal = () =>{
  //   setShowPaymentAlertModal(false);
  //   setShowConfirmModal(false);
  //   setPaymentMessageOfStudy("");
  //   setPaymentStatusOfStudy(0);
  // }

  const mainStackStyles = {
    justifyContent: "center",
    alignItems:'center',
    marginTop: getEnv("REACT_APP_HYBRID_MODE") == "true" ?"20px":"15px",
    display:'flex',
    position: "relative",
    color: "#FAFAFA"
  };

  const onHideContextualMenu = useCallback(() => setShowContextualMenu(false), []);

  const onShowContextualMenu = useCallback((ev) => {
    ev.preventDefault(); // don't navigate
    setShowContextualMenu(true);
  }, []);

  const contextMenuStyle = useMemo(() => ({
    root: {
     backgroundColor: getThemeColor('action-details-background'),
     borderRadius: "5px",
    border: getThemeColor("border"),
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
    },
    item: {
      selectors: {
      ":hover": {
        backgroundColor:'green'
      },
      },
    },
  }), [getThemeColor]);

  const hideContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowContextualMenu(false);
      }, 300)
    );
  };

  const showContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowContextualMenu(true);
      }, 300)
    );
  };

  useEffect(() => {
    clearTimeout(hideContextMenu);
  }, [showContextualMenu]);



  return (
    <>
      {showDeleteModal && showConfirmModal && !showImageDelete &&
          <ConfirmModal handleConfirm={deleteStudyFunc} handleNotConfirm={handleDeleteSuccessCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={t("confirm-message.delete-confirm-message")}
          title={t("confirm-message.confirm-delete-study")} confirmButtonText={t("confirm-message.yes")} cancelButtonText={"Cancel"}/>
      }
      {!showDeleteModal && showConfirmModal && showImageDelete  && 
          <ConfirmModal handleConfirm={deleteStudyFunc} handleNotConfirm={handleDeleteSuccessCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={t("confirm-message.delete-image-confirm-message")}
          title={t("confirm-message.confirm-delete-image")} confirmButtonText={t("confirm-message.yes")} cancelButtonText={"Cancel"}/>
      }
      {showDeleteResponseModal && showConfirmModal &&
          <ConfirmModal handleConfirm={handleDeleteSuccessCloseModal} handleNotConfirm={handleDeleteSuccessCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showDeleteResponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {/* {alertSuccessModal?.show && showConfirmModal &&
        <ConfirmModal handleConfirm={handleReInferenceCloseModal} handleNotConfirm={handleReInferenceCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={t("confirm-message.reInference-message")}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      } */}
      {showCloseStudyModal &&
        <CloseStudy showCloseStudyModal={showCloseStudyModal} setShowCloseStudyModal={setShowCloseStudyModal} setShowCloseStudyResponseModal={setShowCloseStudyResponseModal} studyId={studyId} setShowConfirmModal={setShowConfirmModal} setShowCloseStudyReponseMsg={setShowCloseStudyReponseMsg} patientName={patientName} patientId={patientId}/>
      }
      <ApplyLibraryModal
        show={showLibraryModal}
        studyId={studyId}
        skipLabel={skipLibraryTags}
        onDismiss={() => setShowLibraryModal(false)}
        onSave={handleLibrarySave}
      />
      {showCloseStudyResponseModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseStudyResponseCloseModal} handleNotConfirm={handleCloseStudyResponseCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showCloseStudyReponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showRevertConfirmModal && showConfirmModal && 
        <ConfirmModal handleConfirm={handleRevertCloseStudyApiFunc} handleNotConfirm={handleRevertCloseStudyModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={t("confirm-message.revert-confirmation")}
          title={t("confirm-message.revert-closed-study")} confirmButtonText={t("confirm-message.yes")}/>
      }
      {/* {showRevertReponseModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseRevertResponseModal} handleNotConfirm={handleCloseRevertResponseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showRevertStudyResponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      } */}
      {showLibraryResponseModal &&
        <ConfirmModal handleConfirm={handleCloseLibraryResponseModal} handleNotConfirm={handleCloseLibraryResponseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showLibraryResponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showShareStudyLinkModal && 
        <ShareStudyLink  studyId={props.data.row.original.id} firmId = {props.data.row.original.assignmentList[0].firmId} clientId = {props.data.row.original.assignmentList[0].clientId} setShowShareStudyLinkModal = {setShowShareStudyLinkModal}/>
      }
      {showStudysharingResponse && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseStudySharingFailureModal} handleNotConfirm={handleCloseStudySharingFailureModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showStudySharingResponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showTATTimelineModal &&
        <TATTimeline showTATTimelineModal={showTATTimelineModal} setShowTATTimelineModal={setShowTATTimelineModal} studyId={studyId} patientName={patientName} patientId={patientId} modalityName={study.modality.name} data={props.data.row.original} firmId = {props.data.row.original.assignmentList[0].firmId} providerId={study.assignmentList[0].providerId}/>
      }
      {showPeerReviewModal &&
        <PeerReviewModal showPeerReviewModal={showPeerReviewModal} setShowPeerReviewModal={setShowPeerReviewModal} studyId={studyId} patientName={patientName} patientId={patientId} modalityName={study.modality.name} data={props.data.row.original} firmId = {props.data.row.original.assignmentList[0].firmId} providerId={study.assignmentList[0].providerId}/>
      }
      {showReturnedStudyReasonModal &&
        <ReturnStudy showReturnedStudyReasonModal={showReturnedStudyReasonModal} setShowReturnedStudyReasonModal={setShowReturnedStudyReasonModal} studyId={studyId} patientName={patientName} patientId={patientId}/>
      }

      {showReportHistoryModal &&
        <ReportVersion showReportHistoryModal={showReportHistoryModal} setShowReportHistoryModal={setShowReportHistoryModal} 
        wordFilePath={(study.wordFilePath != null && study.wordFilePath != null && study.wordFilePath != "")?true:false} 
        extReportReceived={study.extReportReceived?true:false}
        studyId={studyId} patientName={patientName} patientId={patientId}/>
      }

      
      {showGatewayStudyStatusModal &&
        <GatewayStatus showGatewayStudyStatusModal={showGatewayStudyStatusModal} setShowGatewayStudyStatusModal={setShowGatewayStudyStatusModal} 
        studyId={studyId} patientName={patientName} patientId={patientId}/>
      }

      {showSendToPacsModal &&
        <SendToPACS showSendToPacsModal={showSendToPacsModal} setShowSendToPacsModal={setShowSendToPacsModal} 
        studyId={studyId}/>
      }

      {showPeerReviewAssignmentModal &&
        <PeerReviewAssignment showPeerReviewAssignmentModal={showPeerReviewAssignmentModal} setShowPeerReviewAssignmentModal={setShowPeerReviewAssignmentModal} 
        studyId={studyId} clientId={props.data.row.original.assignmentList[0]?.clientId} firmId = {props.data.row.original.assignmentList[0]?.firmId} radiologistId = {props.data.row.original.assignmentList[0].providerId.substring(1)} />
      }
      {showEvaluatorAssignmentModal &&
        <EvaluatorAssignment showEvaluatorAssignmentModal={showEvaluatorAssignmentModal} setShowEvaluatorAssignmentModal={setShowEvaluatorAssignmentModal} 
        studyId={studyId} clientId={props.data.row.original.assignmentList[0]?.clientId} firmId = {props.data.row.original.assignmentList[0]?.firmId} radiologistId = {props.data.row.original.assignmentList[0].providerId.substring(1)} />  
      }

      {showEditPatientModal &&
        <EditPatientModal setShowEditPatientModal={setShowEditPatientModal} showEditPatientModal={showEditPatientModal} studyId={studyId} patientName={patientName} patientId={patientId} setShowEditPatientErrorModal={setShowEditPatientErrorModal} setShowEditPatientErrorMessage={setShowEditPatientErrorMessage} data={props.data} />
      }
      {showEditPatientErrorModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseEditPatientErrorModal} handleNotConfirm={handleCloseEditPatientErrorModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showEditPatientErrorMessage}
        title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showStudyAuditLogsModal && (
        <StudyAuditLogsModal
          show={showStudyAuditLogsModal}
          onClose={() => setShowStudyAuditLogsModal(false)}
          studyId={studyId}
        />
      )}
      {showUploadHistoryModal &&
        <UploadHistory setShowUploadHistoryModal={setShowUploadHistoryModal} showUploadHistoryModal={showUploadHistoryModal} 
        studyId={studyId} patientName={patientName} patientId={patientId} setShowUploadHistoryResponseModal={setShowUploadHistoryResponseModal} 
        setShowConfirmModal={setShowConfirmModal} setShowUploadHistoryResponseMessage={setShowUploadHistoryResponseMessage} activeData={props.data.row.original.fromActiveData} 
        clientId={props.data.row.original.assignmentList[0]?.clientId} firmId = {props.data.row.original.assignmentList[0]?.firmId} modalityId = {props.data.row.original.modalityId}
        storageType={props.data.row.original.storageType} reportDoneStatus={props.data.row.original.assignmentList[0]?.reportDoneStatus} />
      }
      {showUploadHistoryResponseModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseUploadHistoryResponseModal} handleNotConfirm={handleCloseUploadHistoryResponseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showUploadHistoryResponseMessage}
        title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showSendReportModal_ &&
        <SendReportEmail showSendReportModal_ = {showSendReportModal_} setShowSendReportModal_ = {setShowSendReportModal_} studyId = {studyId} assignmentList = { props.data.row.original.assignmentList} clientId={props.data.row.original.assignmentList[0]?.clientId} firmId = {props.data.row.original.assignmentList[0]?.firmId}/>
      }
      {shareStudyNotAllowed && 
        <ConfirmModal 
          handleCloseIcon = {() => setShareStudyNotAllowed(false)}
          showConfirmModal = {shareStudyNotAllowed}
          handleConfirm = {() => setShareStudyNotAllowed(false)}
          message = {t("image-archive.share-not-allowed-message")}
          confirmButtonText = {t("confirm-message.ok")}
          title= {t("image-archive.title")}
        />
      }
       {showTypistModal &&
        <TypistAccessCode  setShowTypistModal = {setShowTypistModal} studyId = {studyId} isTypistWorkflowEnabled={isTypistWorkflowEnabled}/>
      }
      {/* {showUploadHistoryDeleteConfirmModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleDelete} handleNotConfirm={handleDeleteCancelModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={alertMessage}
        title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      } */}
      <Stack style={mainStackStyles} data-tut={"tour-action-details"}>
        {/* <IconButton iconProps={{iconName:"More"}} menuProps={menuProps} style={{color:"#8A8886",border:"none",outline:"none"}}/> */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" ,flexDirection:"column"}}>
        <div ref={linkRef} className="study-list-actions-icon" onClick={(e)=>{
          e.stopPropagation();
          e.preventDefault();
          setShowContextualMenu((prev)=>!prev)}
        }  
          onMouseEnter={(e)=>{
            e.stopPropagation();
            showContextMenu();
          }
        }
          onMouseLeave={(e) =>{
            e.stopPropagation();
            hideContextMenu();
          }
        }>
              {/* <MoreIcon /> */}
              {/* <IconButton iconProps={{iconName:"More"}} 
             styles={{
              icon: {color:getThemeColor("icon-color"),border:"none",outline:"none",display:"none"},
              root: {
                backgroundColor: 'transparent'
              },
              rootHovered: {backgroundColor: 'transparent'},
              rootPressed: {backgroundColor: 'transparent'}
            }}/>  */}
                <Icon
                iconName="ActionDownArrowIcon"
                style={{display:"flex"}}
                onClick={(e)=>{e.stopPropagation();e.preventDefault();setShowContextualMenu((prev)=>!prev)}}
              ></Icon>
              <div onMouseLeave={(e)=>{e.stopPropagation(); clearTimeout(delayHandler);setShowContextualMenu(false)}}>
              {showContextualMenu && <ContextualMenu
                styles={contextMenuStyle}
                items={getActionMenuItems()}
                calloutProps={CONTEXTUAL_MENU_CALLOUT_PROPS}
                target={linkRef}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
              />}
                </div>
            </div>
            <CustomToolTipHost content="Copy Patient and Study details">
              <IconButton
                iconProps={{ iconName: "Copy" }}
                onClick={handleCopyPatientStudyDetails}
                styles={{
                  root: {
                    width: "24px",
                    height: "24px",
                    minWidth: "24px",
                    padding: 0,
                    color: getThemeColor("icon-color"),
                    backgroundColor: "transparent",
                  },
                  rootHovered: {
                    color: getThemeColor("icon-color"),
                    backgroundColor: "transparent",
                  },
                  rootPressed: {
                    color: getThemeColor("icon-color"),
                    backgroundColor: "transparent",
                  },
                  rootFocused: {
                    backgroundColor: "transparent",
                  },
                  icon: {
                    fontSize: "14px",
                  },
                }}
              />
            </CustomToolTipHost> 
            </div>
      </Stack>
      {showSetEmergencyModal && (
        <SetEmergencyModal
          show={showSetEmergencyModal}
          onClose={() => setShowSetEmergencyModal(false)}
          dataRow={props.data.row.original}
          defaultKey={props.data.row.original?.nonMedicalEmergency ? 3 : 2}
            onSubmit={(key) => updateEmergency(key === 3 ? 'NON_MEDICAL' : 'MEDICAL')}
        />
      )
        }
    </>
  );
};

export default ActionDetails;



     